var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zlNotes" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.notesLoading,
            expression: "notesLoading"
          }
        ],
        staticClass: "note-list"
      },
      [
        _vm.noteList && _vm.noteList.length
          ? [
              _c(
                "div",
                { staticClass: "note_tab" },
                _vm._l(_vm.tabList, function(item, index) {
                  return _c(
                    "p",
                    {
                      key: index,
                      staticClass: "note_tab_p",
                      class: { activeStyle: _vm.type === index },
                      on: {
                        click: function($event) {
                          return _vm.activeThis(index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t    " + _vm._s(item) + "\n\t\t\t\t\t  "
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm._l(_vm.noteList, function(item, index) {
                return _c(
                  "div",
                  { key: index + "noteList", staticClass: "note-item" },
                  [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "right_portrait" }, [
                      _c("div", { staticClass: "top" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.username))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(item.date))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "status",
                            style: _vm.handleStatus(item.noteType)
                          },
                          [_vm._v(_vm._s(item.noteType))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          {
                            class: {
                              "total-introduce": item.showTotal,
                              "detailed-introduce": !item.showTotal
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                ref: "desc",
                                refInFor: true,
                                staticClass: "intro-content",
                                attrs: { title: item.content }
                              },
                              [
                                _c("p", {
                                  staticClass: "merchant-desc",
                                  domProps: { innerHTML: _vm._s(item.content) }
                                }),
                                _vm._v(" "),
                                item.showExchangeButton
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "unfold",
                                        on: {
                                          click: function($event) {
                                            return _vm.showTotalIntro(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              item.exchangeButton
                                                ? "展开"
                                                : "收起"
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("img", {
                            attrs: {
                              src: "/static/images/study/icon/zhangjie.png"
                            }
                          }),
                          _vm._v(" "),
                          item.catalogName
                            ? _c("span", [_vm._v(_vm._s(item.catalogName))])
                            : _c("span", [_vm._v("全部章节")])
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "right" }, [
                          !item.isUserPraise
                            ? _c(
                                "li",
                                {
                                  staticClass: "dianzan",
                                  on: {
                                    click: function($event) {
                                      return _vm.assist(item.noteId)
                                    }
                                  }
                                },
                                [
                                  _c("div"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.notePraiseNumber))
                                  ])
                                ]
                              )
                            : _c(
                                "li",
                                {
                                  staticClass: "y_dianzan",
                                  on: {
                                    click: function($event) {
                                      return _vm.unassist(item.noteId)
                                    }
                                  }
                                },
                                [
                                  _c("div"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.notePraiseNumber))
                                  ])
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "pinglun",
                              on: {
                                click: function($event) {
                                  return _vm.getComment(item, index)
                                }
                              }
                            },
                            [
                              _c("div"),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.replyNumber))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "note_editor",
                              on: {
                                click: function($event) {
                                  return _vm.editorNote(item)
                                }
                              }
                            },
                            [_c("div")]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "delete",
                              on: {
                                click: function($event) {
                                  return _vm.delNote(item.noteId)
                                }
                              }
                            },
                            [_c("div")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      item.status == 1
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.noteLoading,
                                  expression: "noteLoading"
                                }
                              ],
                              staticClass: "commentCont"
                            },
                            [
                              _c("div", { staticClass: "comment1" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment2" }, [
                                _c(
                                  "div",
                                  { staticClass: "comment2_cont" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pinglun_text" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            resize: "none",
                                            placeholder: "请输入内容",
                                            maxlength: "300",
                                            "show-word-limit": ""
                                          },
                                          model: {
                                            value: _vm.discussionContent,
                                            callback: function($$v) {
                                              _vm.discussionContent = $$v
                                            },
                                            expression: "discussionContent"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled: _vm.disabledBtn
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.publish(item)
                                                  }
                                                }
                                              },
                                              [_vm._v("发表")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.commentList.length
                                      ? _c("el-divider")
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(item.commentList, function(v, i) {
                                      return _c(
                                        "div",
                                        { key: i, staticClass: "comment-item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "commentContent" },
                                            [
                                              _vm._v(
                                                "\n              \t\t\t\t\t" +
                                                  _vm._s(v.replyContent) +
                                                  "\n              \t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "comment-bottom" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "left" },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(v.userName))
                                                  ]),
                                                  v.isTeacherReply
                                                    ? _c(
                                                        "i",
                                                        {
                                                          staticClass: "zhiwei"
                                                        },
                                                        [_vm._v("教师")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(v.date))
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              v.isDelete
                                                ? _c("div", {
                                                    staticClass: "right",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.delComment(
                                                          v.replyId,
                                                          v.learnId
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment3" })
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              })
            ]
          : _c(
              "div",
              { staticClass: "isEmpty" },
              [
                _c(
                  "el-empty",
                  { attrs: { "image-size": 100, description: " " } },
                  [
                    _c("p", [_vm._v("暂无内容,快来记一笔吧")]),
                    _vm._v(" "),
                    _c("p", [_vm._v("良好的笔记习惯有助于课堂吸收和课后复习")])
                  ]
                )
              ],
              1
            )
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "note-text" },
      [
        _c("editor", {
          attrs: {
            toolMenus: _vm.editorMenus,
            height: "200px",
            onlyKey: _vm.noteFlag
          },
          model: {
            value: _vm.noteCont,
            callback: function($$v) {
              _vm.noteCont = $$v
            },
            expression: "noteCont"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottombtn" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.isOpen,
                  callback: function($$v) {
                    _vm.isOpen = $$v
                  },
                  expression: "isOpen"
                }
              },
              [_vm._v("公开")]
            ),
            _vm._v(" "),
            _vm.noteId
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.editorSaveNote()
                      }
                    }
                  },
                  [_vm._v("保 存")]
                )
              : _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addNote()
                      }
                    }
                  },
                  [_vm._v("保 存")]
                )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left_portrait" }, [
      _c("img", { attrs: { src: "/static/images/study/icon/teacher.png" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cebee73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cebee73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/zlNotes.vue
// module id = null
// module chunks = 